/**
 * https://pretagteam.com/question/best-way-to-generate-unique-ids-clientside-with-javascript
 */
export function uuid(): string {
  return window.crypto.getRandomValues(new Uint32Array(1))[0].toString();
}
